export const AUTO_COMPLETE_NUMBER_PER_PAGE = 20;
export const LIST_DEFAULT_LIMIT_MAX_SIZE = 1000;
export const LIST_NUMBER_PER_PAGE = 20;